// Subscription mini card component for dashboard
import { subscription } from '@/mocks/subscription';

export function SubscriptionMiniCard() {
  const isActive = subscription.panelUsageStatus === 'Aktif';
  const paymentDone = subscription.monthlyPaymentStatus === 'Yapıldı';

  return (
    <div
      className="spa-card p-4 flex items-start gap-3 cursor-pointer"
      style={{
        borderLeft: `3px solid ${isActive ? '#10B981' : paymentDone ? '#F59E0B' : '#EF4444'}`,
      }}
    >
      <div
        className="w-9 h-9 rounded-spa-sm flex items-center justify-center flex-shrink-0"
        style={{ background: isActive ? 'rgba(16,185,129,0.12)' : paymentDone ? 'rgba(245,158,11,0.12)' : 'rgba(239,68,68,0.12)' }}
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i
            className={`${isActive ? 'ri-shield-check-line' : paymentDone ? 'ri-alert-line' : 'ri-forbid-line'} text-base`}
            style={{ color: isActive ? '#10B981' : paymentDone ? '#F59E0B' : '#EF4444' }}
          />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold truncate" style={{ color: 'var(--text-primary)' }}>
          {isActive ? 'Panel Kullanımı Aktif' : paymentDone ? 'Panel Kullanımı Uyarıda' : 'Panel Pasif'}
        </p>
        <p className="text-xs mt-1" style={{ color: 'var(--text-secondary)' }}>
          {isActive
            ? 'Bu ay panel kullanımınız aktiftir.'
            : paymentDone
            ? 'Bu ay hizmet ödemeniz beklemede görünüyor. Panel kullanımınızın kesintisiz devam etmesi için danışmanınızla iletişime geçebilirsiniz.'
            : 'Panel kullanımınız geçici olarak pasif durumdadır. Detaylı bilgi için destek ekibiyle iletişime geçiniz.'}
        </p>
      </div>
    </div>
  );
}